/**
 * Created by katarinababic on 11.6.25.
 */
import * as React from 'react';
import { observer } from 'mobx-react';
import { useEffect } from 'react';
import { WeekDayEntryEvent } from '../../Model/Coach/Schedule/WeekDayEntryEvent';
import { useRootStore } from '../../Store/useRootStore';
import { useTrans } from '../../Store/System/LocalizationStore';
import { useDeleteAllEvents } from '../../Hooks/useEventEntryMutations';

export type WorkoutDayCardEventHealthDataPointProps = {
  entry: WeekDayEntryEvent;
};

export const WorkoutDayCardEventHealthDataPoint: React.FC<WorkoutDayCardEventHealthDataPointProps> = observer(
  ({ entry }) => {
    const { analytics } = useRootStore();
    const { t } = useTrans();
    const deleteAllEvents = useDeleteAllEvents();

    const title = t(`workoutDayCard.event.healthDataPoint.title`, {
      defaultValue: 'Log your {{value}}',
      value: t(`athlete.bodyValues.${entry.event.objectId}`),
    });

    const handlePress = React.useCallback(() => {
      // TODO show value modal
      // navigation.navigate('HealthDataPointValueModal', {
      //   valueKey: entry.event.objectId as HealthDataPointObjectType,
      //   eventId: entry.event.id,
      // });
    }, []);

    const removeAllEvents = React.useCallback(() => {
      deleteAllEvents.mutateAsync(entry.event).then((event) => {
        analytics.logEvent('event_unscheduled', {
          content_type: event.objectType,
          item_id: event.objectId,
          aiPlanned: event.aiPlanned,
          startTime: event.startTime,
          startDate: event.startDate,
        });
      });
    }, [analytics, deleteAllEvents, entry]);

    const handleLongPress = React.useCallback(() => {
      const alertTitleValue = t('explore.scheduler.removeAlert.titleSession', {
        value: title,
      });

      const alertTitleMessage = t('explore.scheduler.removeAlert.messageSession', {
        value: title,
      });

      // TODO implement alert
      // Alert.alert(alertTitleValue, alertTitleMessage, [
      //   {
      //     text: t('explore.scheduler.removeAlert.removeAllEvents', {
      //       value: title,
      //     }),
      //     style: 'destructive',
      //     onPress: () => removeAllEvents(),
      //   },
      //   {
      //     style: 'cancel',
      //     text: t('globals.cancel'),
      //   },
      // ]);
    }, [t, title]);

    return null;
  },
);
